import { useContext } from "react";
import { ListingsMatchContext } from "contexts/ListingsMatchContext";
import type { SearchState } from "contexts/ListingsMatchContext";
import { useTranslation } from "react-i18next";
import { AutocompleteMultiSelect } from "components/__haim/Common/AutocompleteMultiSelect";
import { useAgencyNames } from "hooks/useAgencyNames";
import { SyntheticEvent } from "react";
import { AutocompleteInputChangeReason } from "@material-ui/core";

type AgencyNamesPickerProps = {
  draftSearchState?: SearchState;
  setDraftSearchState?: (s: Partial<SearchState>) => void;
};

export function AgencyNamesPicker(props: AgencyNamesPickerProps = {}) {
  const { t: translate } = useTranslation();

  const { agencyNames, loading, setSearch } = useAgencyNames();

  const ctx = useContext(ListingsMatchContext);
  const draftSearchState = props.draftSearchState ?? ctx?.draftSearchState;
  const setDraftSearchState = props.setDraftSearchState ?? ctx?.setDraftSearchState;

  const handleSearchChange = (
    event: SyntheticEvent,
    newValue: string,
    reason: AutocompleteInputChangeReason
  ) => {
    if (reason !== "input") return;

    setSearch(newValue);
  };

  return (
    <AutocompleteMultiSelect
      label={translate("listingsMatch.filters.agencyNamesTitle")}
      emptyLabel={translate("listingsMatch.filters.allOptions")}
      value={draftSearchState.agencyNames}
      options={agencyNames}
      loading={loading}
      onChange={(value) => setDraftSearchState({ agencyNames: value })}
      onInputChange={handleSearchChange}
    />
  );
}
